if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        // Prevent double-add: open cart drawer instead
        if (this.submitButton.hasAttribute('data-added')) {
          var drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.open === 'function') drawer.open();
          else window.location.href = window.routes.cart_url;
          return;
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        // ── Everspring greeting card ──────────────────────────────────
        // The greeting-card app block renders a checkbox + textarea and
        // relies on a hidden input it injects into the form. On this custom
        // PDP that injection isn't reliably picked up, so we read the
        // textarea directly here and attach the message as a line-item
        // property. Respects the app's configured property name (via the
        // hidden input) and only adds it when the box is ticked and a
        // message was written. No-op on pages without the greeting card.
        (function attachGreetingCard() {
          const gcToggle = document.getElementById('everspring_greetingcard-toggle');
          const gcTextarea = document.getElementById('everspring_greetingcard-textarea');
          if (!gcToggle || !gcToggle.checked || !gcTextarea) return;
          const message = gcTextarea.value.trim();
          if (message === '') return;

          let propName = 'gift_card_text';
          const gcHidden = document.getElementById('everspring_greetingcard-hidden');
          if (gcHidden && gcHidden.name) {
            const match = gcHidden.name.match(/^properties\[(.+)\]$/);
            if (match) propName = match[1];
          }

          const key = 'properties[' + propName + ']';
          if (!formData.get(key)) formData.set(key, gcTextarea.value);
        })();
        // ──────────────────────────────────────────────────────────────

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            // PostHog: track add_to_cart event
            if (!this.error && window.posthog && typeof window.posthog.capture === 'function') {
              try {
                window.posthog.capture('add_to_cart', {
                  product_id: response.product_id,
                  product_title: response.product_title || response.title,
                  variant_id: response.variant_id || response.id,
                  variant_title: response.variant_title,
                  price: (response.price || response.final_price || 0) / 100,
                  quantity: response.quantity,
                  line_price: (response.line_price || response.final_line_price || 0) / 100,
                  source: 'product-form'
                });
              } catch (e) { console.warn('[posthog] add_to_cart capture failed', e); }
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) {
              this.submitButton.removeAttribute('aria-disabled');
              // Prevent double-add: mark as added
              this.submitButton.setAttribute('data-added', 'true');
              var btnTextEl = this.submitButton.querySelector('.es-pdp__atc-btn-text') || this.submitButtonText;
              if (btnTextEl) btnTextEl.textContent = '✓ Toegevoegd';
            }
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
